import React, { useEffect, useState } from "react";
import moment from "moment";
import { Card } from "react-bootstrap";
import { RiErrorWarningLine } from "react-icons/ri";
import { setselectedemail } from "../../../../redux/actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl } from "../../../../container/BaseUrl/BaseUrl";
import { BiTransferAlt } from "react-icons/bi";
import { MdOutlineCallMerge } from "react-icons/md";

const mapStateToProps = (state) => {
  return {
    chat: state.data.chat,
    selectedemail: state.data.selectedemail,
  };
};

const Sessiontab = (props) => {
  const [userchathistory, setUserchathistory] = useState([]);

  const getChatHistoryDetails = async () => {
    try {
      let session_id = props.chat.chat_session_id;
      const sessions = await axios.post(
        BaseUrl + "/users/listchatHistory",
        {
          session_id: session_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      
      if (sessions.data.status) {
        setUserchathistory(sessions.data.data);
      } else {
        setUserchathistory([]);
      }
    } catch (error) {
      
    }
  };

  useEffect(() => {
    if (props.selectedemail) {
      getChatHistoryDetails();
    }
  }, [props.selectedemail]);

  
  return (
    <>
      <div
        className={props.SessionHistorytab}
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <div className="m-2 file-main">
          <div className="chat-r-file">
            <div className="tab_content_userinfo">
              {userchathistory.length > 0 ? (
                userchathistory.map((item) => (
                  <Card
                    key={item.id}
                    style={{
                      width: "90%",
                      height: "5rem",
                      marginLeft: "20px",
                    }}
                    className="mt-3 pl-3 shadow"
                  >
                    <div
                      className="text-center d-flex mt-3 "
                      style={{ overflowY: "auto" }}
                    >
                      {item.type == "Transfer" ? (
                        <div>
                          <BiTransferAlt size={25} />
                        </div>
                      ) : (
                        <div>
                          <MdOutlineCallMerge size={25} />
                        </div>
                      )}
                      {item.type == "Transfer" ? (
                        <div>
                          <span
                            style={{
                              fontWeight: "bold",
                              fontSize: 12,
                              fontFamily: "poppins",
                              position: "absolute",
                              left: "45px",
                            }}
                          >
                            Interaction Transferred From {item.agent} to{" "}
                            {item.destinationAgent}
                          </span>
                        </div>
                      ) : (
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              paddingLeft: 10,
                              fontSize: 12,
                              fontFamily: "poppins",
                            }}
                          >
                            {item.agent} conferenced with{" "}
                            {item.destinationAgent}
                          </p>
                        </div>
                        
                      )}
                    </div>
                    <div>
                      <span
                        style={{
                          fontSize: 10,
                          color: "#000",
                          fontWeight: "400",
                          position: "absolute",
                          top: 51,
                          left: "50px",
                          fontFamily: "poppins",
                        }}
                      >
                        {moment(item.time).format("LLL")}
                      </span>
                    </div>
                  </Card>
                ))
              ) : (
                <div className="d-flex justify-content-center">
                  <div
                    className="text-muted d-flex"
                    style={{
                      flexDirection: "column",
                      marginTop: "20%",
                      width: "400px",
                      height: "100px",
                    }}
                  >
                    <span className="mx-auto">
                      <RiErrorWarningLine size={30} />
                    </span>
                    <span className="mx-auto">
                      <h6
                        className="text-muted mt-2"
                        style={{ fontFamily: "poppins" }}
                      >
                        No Session History Found
                      </h6>
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setselectedemail,
})(Sessiontab);
